<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="1" tab-position="left" style="background-color: #FFFFFF;height: 800px" @tab-click="handleClick">
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8" style="position: relative">
                <el-button type="primary" size="mini" @click="handleAdd(type)">新增</el-button>
                <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
                <clear-cache-apply v-if="type==1" />
                <CommonExcel ref="CommonExcelRef2" style="position:absolute;top: 5px;left: 339px;" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
                <sync-data />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 60%;" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.num" style="width: 250px;" placeholder="点击次数" />
                </template>
              </el-table-column>
              <el-table-column label="奖励" align="center">
                <template v-slot:default="{row}">
                  <Reward v-model="row.reward" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="150">
                <template v-slot:default="{row}">
                  <el-button type="danger" size="mini" @click="handleDel(type,$index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>
  </BasicLayout>
</template>

<script>

import Reward from '@/components/Reward'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { actionCollectionRoomProgress, collectionRoomProgress, delCollectionRoomProgress } from '@/api/config/api'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { handleImportPrize } from '@/utils'
import { downloadExcelMultiSheet } from '@/utils/excel'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'DailyShare',
  components: { SyncData, CommonExcel, ClearCacheApply, Reward },
  data() {
    return {
      type: 1,
      loading: false,
      list: { 1: [], 2: [], 3: [] },
      typeArr: { 1: '野兽配置', 2: '骰子配置', 3: '盾牌配置' }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getList() {
      this.loading = true
      this.list = { 1: [], 2: [], 3: [] }
      collectionRoomProgress().then(response => {
        for (let i = 0; i < response.data.length; i++) {
          const row = response.data[i]
          this.list[row.type].push(row)
        }
        this.loading = false
      })
    },
    handleClick(tab, event) {
      this.type = parseInt(tab.index) + 1
    },
    handleAdd(type, data = []) {
      if (data.length > 0) {
        data.forEach(item => {
          item.type = type
          this.list[type].push(item)
        })
        return
      }
      this.list[type].push({ type: type, num: 3, reward: [] })
    },
    handleDel(type, index, id) {
      this.$confirm('确认要删除吗?', '警告', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        if (id !== 0) {
          delCollectionRoomProgress({ id: id }).then(response => {
            this.msgSuccess('删除成功', () => {
              this.getList()
            }, 1000)
          })
        }
        this.list[type].splice(index, 1)
      })
    },
    handleSaveConfig() {
      const tmp = []
      for (const typeN in this.typeArr) {
        for (let i = 0; i < this.list[typeN].length; i++) {
          tmp.push(this.list[typeN][i])
        }
      }
      actionCollectionRoomProgress({ data: JSON.stringify(tmp) }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      this.list[this.type] = []
      for (let i = 0; i < excelData.length; i++) {
        this.handleAdd(this.type, handleImportPrize(excelData[i].sheetData))
      }
    },
    exportCfg(type) {
      const nameArr = [this.typeArr[1]]
      const dataArr = [this.list[this.type]]
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      const tranTitle = {
        num: '数量',
        reward: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
      }

      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2[0].makeExcelData(dataArr[i], tranTitle)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    }
  }
}
</script>

